import { render } from "./smsCard.vue?vue&type=template&id=6740b543&scoped=true"
import script from "./smsCard.vue?vue&type=script&lang=js"
export * from "./smsCard.vue?vue&type=script&lang=js"

import "./smsCard.vue?vue&type=style&index=0&id=6740b543&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6740b543"

export default script